<template>
  <div class="login-container">
    <el-form
      ref="loginForm"
      :model="loginForm"
      :rules="rules"
      class="login-form"
      label-position="left"
    >
      <div class="title-container">
        <h3 class="title">运营商后台管理系统</h3>
      </div>
      <el-form-item label="手机号" prop="name">
        <el-input v-model="loginForm.name" placeholder="请输入手机号" />
      </el-form-item>
      <el-form-item label="密码" prop="pwd">
        <el-input
          v-model="loginForm.pwd"
          placeholder="请输入密码"
          show-password
        />
      </el-form-item>
      <div class="checked">
        <el-checkbox v-model="checked">记住密码</el-checkbox>
      </div>
      <el-button
        :loading="loading"
        style="width: 100%"
        type="primary"
        @click="handleLogin"
        >登录</el-button
      >
    </el-form>
  </div>
</template>

<script>
import agentGetOwnDetails from "@/api/user/agent-manage/agentGetOwnDetails";
import getAppidByAgentCode from "@/api/user/agent-manage/getAppidByAgentCode";
import scanMixin from "@/mixin/scanMixin";
import UserPwd from "@/utils/UserPwd";
import { checkPhone } from "@/utils/check";
import TokenStore from "@/utils/tokenStore";
import { mapActions, mapMutations } from "vuex";

export default {
  name: "Login",
  mixins: [scanMixin],
  data: () => {
    return {
      checked: false,
      rules: {
        name: checkPhone,
        pwd: [
          { required: true, message: "请输入密码" },
          { min: 6, max: 20, message: "长度在6到20个字符" },
        ],
      },
      loginForm: {
        client_id: "agent",
        client_secret: "agent",
        grant_type: "agent",
        name: "",
        pwd: "",
      },
      loading: false,
      redirect: undefined,
    };
  },
  created() {
    // 来自于管理员登录运营商功能
    if (this.$route.query.from_admin_token) {
      this.SET_TOKEN(this.$route.query.from_admin_token);
      TokenStore.setToken("operators", this.$route.query.from_admin_token);
      agentGetOwnDetails().then((res) => {
        this.setInfo(res.data);
        this.loading = false;

        this.navigateHome();
      });
    } else if (this.$route.query.pwd && this.$route.query.account) {
      this.loginForm.name = this.$route.query.account;
      this.loginForm.pwd = this.$route.query.pwd;
      this.login(this.loginForm)
        .then(() => {
          agentGetOwnDetails().then((res) => {
            this.setInfo(res.data);
            this.loading = false;
            if (this.checked === true) {
              UserPwd.setUserPwd(this.loginForm);
            }

            this.navigateHome();
          });
        })
        .catch((e) => {
          console.log(e);
          this.loading = false;
        });
    }
    if (UserPwd.has()) {
      this.loginForm.name = UserPwd.getUserPwd().name;
      this.loginForm.pwd = UserPwd.getUserPwd().pwd;
    }
  },
  watch: {
    $route: {
      handler: function (route) {
        this.redirect = route.query && route.query.redirect;
      },
      immediate: true,
    },
  },
  methods: {
    ...mapMutations(["SET_TOKEN"]),
    ...mapActions(["login", "setInfo"]),
    // 导航到首页
    navigateHome() {
      // pc端直接进入首页
      if (this.device === "desktop") {
        this.$router.push({ path: this.redirect || "/" });
      } else {
        // 如果是使用微信客户端进行登录操作，重定向到静默授权页面，获取当前微信用户的code信息后，再重定向到首页
        getAppidByAgentCode().then((res) => {
          location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${
            res.data
          }&redirect_uri=${encodeURIComponent(
            `http://${window.location.hostname}/home`
          )}&response_type=code&scope=snsapi_userinfo#wechat_redirect`;
        });
      }
    },
    handleLogin() {
      this.$refs["loginForm"].validate((valid) => {
        if (valid) {
          this.loading = true;
          this.login(this.loginForm)
            .then(() => {
              agentGetOwnDetails().then((res) => {
                if (!res.data || res.data == "null") {
                  this.$message.error("登录失败，请重新登录！");
                  this.loading = false;
                  return;
                }
                this.setInfo(res.data);
                this.loading = false;
                if (this.checked === true) {
                  UserPwd.setUserPwd(this.loginForm);
                }

                this.navigateHome();
              });
            })
            .catch((e) => {
              console.log(e);
              this.loading = false;
            });
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.checked {
  color: white;
  margin-left: auto;
  position: relative;
  height: 30px;

  label {
    position: absolute;
    right: 0;
    color: white !important;
  }
}

$bg: #2d3a4b;
$light_gray: #eee;

.login-container {
  min-height: 100%;
  width: 100%;
  background-color: $bg;
  overflow: hidden;

  .login-form {
    position: relative;
    width: 520px;
    max-width: 100%;
    padding: 160px 35px 0;
    margin: 0 auto;
    overflow: hidden;
  }

  .title-container {
    position: relative;

    .title {
      font-size: 26px;
      color: $light_gray;
      margin: 0 auto 40px auto;
      text-align: center;
      font-weight: bold;
    }
  }
}
</style>
